import type { BlockList } from '../types';

export function isPetitionBlocked(id: string, blocklist: BlockList) {
	return blocklist && blocklist.some(({ petitionId }) => petitionId === id);
}
